var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupSuccessExtended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 180 137",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 39.333 122.52)",
    width: 19.667,
    height: 51.288,
    fill: "#0000C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 39.333 122.52)",
    width: 19.667,
    height: 51.288,
    fill: "url(#i)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 19.667 122.52)",
    width: 19.667,
    height: 37.405,
    fill: "#0000C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 19.667 122.52)",
    width: 19.667,
    height: 37.405,
    fill: "url(#h)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 0 122.52)",
    width: 19.667,
    height: 23.908,
    fill: "#0000C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 0 122.52)",
    width: 19.667,
    height: 23.908,
    fill: "url(#g)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m134.36 111.26c-2.923-2.395-7.213-1.99-9.584 0.905s-1.923 7.18 1 9.575c2.924 2.394 7.213 1.989 9.584-0.905 2.371-2.895 1.924-7.18-1-9.575zm-5.77 7.044c-1.008-0.826-1.162-2.299-0.344-3.297 0.817-0.999 2.292-1.138 3.3-0.312 1.009 0.826 1.163 2.299 0.345 3.298-0.809 1.006-2.293 1.137-3.301 0.311zm39.561-7.192c-2.923-2.395-7.212-1.99-9.583 0.905-2.372 2.895-1.924 7.18 1 9.574 2.923 2.395 7.212 1.99 9.584-0.905 2.371-2.894 1.923-7.179-1.001-9.574zm-5.77 7.044c-1.008-0.826-1.162-2.299-0.344-3.297 0.818-0.999 2.292-1.138 3.301-0.312 1.008 0.826 1.162 2.299 0.344 3.298-0.808 1.006-2.292 1.137-3.301 0.311zm5.327-18.826c-9.188-12.393-16.612-14.617-29.773-13.534-19.934 1.5189-23.58 10.915-23.334 27.525-4e-3 0.043 1e-3 0.093-3e-3 0.136 0.023 1.35 1.131 2.488 2.543 2.481l3.619-0.02c0.252-4.876 4.213-8.749 9.168-8.777 4.964-0.021 9.028 3.813 9.427 8.686l15.271-0.073c0.252-4.875 4.204-8.756 9.168-8.777 4.964-0.02 9.028 3.813 9.427 8.686l2.807-0.011c1.396-5e-3 2.486-1.148 2.471-2.507-0.059-3.401 1.055-9.667-10.791-13.814zm-45.529 0.1156c1.928-5.3546 8.873-7.8698 14.483-8.5094l0.12 8.4404-14.603 0.069zm18.612-0.0757-0.134-8.7433c10.411-0.5183 14.747 1.7937 20.573 8.6474l-20.439 0.0959z",
    fill: "#0000C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.215 48.068c0-1.5827 1.4868-3.1948 2.9445-3.1948h31.048c1.4868 0 2.9447 1.6121 2.9447 3.1948v12.78h-36.937v-12.78zm29.561 31.949c0.9912-0.6742 0.9912-0.6742 1.8367-0.4104 0.4956 0.1759 1.0786 1.2897 0.7288 1.5828l-7.7548 25.559c-0.1457 0.85-0.379 1.378-1.1078 1.378-0.379 0-0.962-0.528-1.4868-0.967l-4.0523-4.397-9.6206 10.376c-0.379 0.41-1.341 1.26-1.341 1.26-0.3207 0.176-0.4956 0.264-0.9621 0-0.962-0.527-0.4956-1.582-0.2915-2.462l7.7548-25.559c0.2915-0.7913 0.5247-1.3189 1.2535-1.3189 0.7289 0 0.9621 0.5275 1.3411 0.9086l4.0523 4.3966 9.6497-10.347zm14.781 52.701v-84.65c0-5.9794-4.811-11.197-10.35-11.197h-31.019c-5.5392 0-10.349 5.188-10.349 11.197v84.65",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.45 133.45h-92.124c-0.4081 0-0.7288-0.323-0.7288-0.733s0.3207-0.733 0.7288-0.733h92.124c0.408 0 0.729 0.323 0.729 0.733s-0.321 0.733-0.729 0.733z",
    fill: "#0300C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.85 36.089c-0.087-0.0586-0.174-0.1172-0.233-0.2052-0.35-0.4396-0.262-1.1138 0.175-1.4362l10.67-8.3536c0.438-0.3517 1.108-0.2638 1.429 0.1759 0.35 0.4396 0.262 1.1138-0.175 1.4362l-10.641 8.3536c-0.379 0.2931-0.875 0.2931-1.225 0.0293z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.095 24.115c-0.0875-0.0293-0.2041-0.0586-0.2916-0.1172-0.4664-0.3225-0.6122-0.938-0.3207-1.4363l7.3176-11.431c0.321-0.469 0.933-0.6155 1.428-0.3224 0.467 0.3224 0.613 0.9379 0.321 1.4362l-7.3174 11.431c-0.2624 0.3811-0.7288 0.5276-1.1369 0.4397z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.339 24.067c-0.0583 0.0879-0.1166 0.1759-0.2041 0.2345-0.4373 0.381-1.0787 0.3224-1.4576-0.1172l-8.8043-10.288c-0.379-0.4396-0.3207-1.0845 0.1166-1.4655s1.0787-0.3224 1.4577 0.1172l8.8334 10.318c0.2624 0.3224 0.2915 0.8207 0.0583 1.2017z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.064 36.707c-0.0211 0.1153-0.0656 0.1964-0.1154 0.3063-0.2957 0.4813-0.9451 0.6281-1.4242 0.3299l-11.443-7.2959c-0.4791-0.2982-0.6263-0.9517-0.3307-1.433 0.2957-0.4813 0.9452-0.6282 1.4242-0.3299l11.448 7.2671c0.3984 0.2533 0.5486 0.7285 0.4408 1.1555z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.712 22.457c-0.0958 0.0414-0.1858 0.054-0.3038 0.061-0.562 0.0409-1.0304-0.3799-1.0595-0.9554l-0.7167-13.576c-0.0291-0.57549 0.3905-1.0639 0.9525-1.1048 0.5619-0.04088 1.0304 0.37994 1.0594 0.95544l0.7168 13.576c0.0466 0.489-0.2374 0.8837-0.6487 1.0438z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.049 71.429c-0.2916 9.3794-4.8686 20.664-12.39 20.664-7.5216 0-12.682-11.871-12.099-20.664 1.2536-18.788 12.827-30.776 12.827-30.776s11.661 11.959 11.661 30.776z",
    fill: "#0300C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.279 132.69c-0.4081 0-0.7288-0.323-0.7288-0.733l-0.1749-52.115c0-0.4103 0.3207-0.7327 0.7288-0.7327 0.4082 0 0.7289 0.3224 0.7289 0.7327l0.1749 52.115c0 0.41-0.3207 0.733-0.7289 0.733z",
    fill: "#0300C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.42 115.81c-2.974-0.938-5.685-3.195-6.239-6.243-0.408-2.228 0.408-4.66-0.466-6.771-0.758-1.905-2.711-3.0774-4.0816-4.6016-3.7608-4.1914-2.653-11.636 2.1866-14.568 2.624-1.5827 6.005-1.9638 8.104-4.1328 1.954-2.0224 2.304-5.0121 3.47-7.5329 1.545-3.3414 4.839-6.0087 8.542-6.2432 3.731-0.2345 7.579 2.3449 8.192 5.9794 0.32 1.8466-0.175 3.7518 0.116 5.5984 0.496 3.3708 3.353 5.8622 5.773 8.295 2.419 2.4328 4.722 5.7449 3.76 9.0277-0.67 2.3156-2.886 4.1035-3.032 6.5365-0.116 1.993 1.225 3.781 1.691 5.745 0.962 4.133-2.478 8.236-6.53 9.643-3.819 1.319-7.755 0.791-11.632 0.322-3.207-0.439-6.676-0.058-9.854-1.055z",
    fill: "#04DFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.6 83.771c-0.379-0.2345-0.933-0.1759-1.225 0.1466l-8.483 9.2036v-12.164c0-0.3811-0.379-0.7035-0.875-0.7035-0.466 0-0.874 0.3224-0.874 0.7035v28.96l-8.746-9.497c-0.292-0.323-0.846-0.381-1.225-0.147-0.379 0.235-0.466 0.674-0.175 0.997l10 10.845c0.029 0.029 0.087 0.088 0.146 0.117v19.58c0 0.381 0.379 0.703 0.874 0.703 0.467 0 0.875-0.322 0.875-0.703v-36.346l9.883-10.698c0.291-0.2931 0.233-0.7621-0.175-0.9966z",
    fill: "#0300C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 9.8333,
    x2: 9.8333,
    y2: 51.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 9.8333,
    x2: 9.8333,
    y2: 37.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 9.8333,
    x2: 9.8333,
    y2: 23.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 56.83,
    x2: 108.57,
    y1: 84.796,
    y2: 84.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 115.51,
    x2: 125.48,
    y1: 26.7,
    y2: 29.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 96.635,
    x2: 106.9,
    y1: 14.636,
    y2: 13.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 49.303,
    x2: 51.416,
    y1: 22.686,
    y2: 12.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 34.596,
    x2: 33.64,
    y1: 38.554,
    y2: 28.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 70.938,
    x2: 78.796,
    y1: 15.854,
    y2: 9.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0017BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032CC3",
    offset: 0.033867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0857CB",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7ED2",
    offset: 0.1983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119ED8",
    offset: 0.2888
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B8DD",
    offset: 0.3859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17CDE1",
    offset: 0.4921
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DBE4",
    offset: 0.6122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE3E6",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE6E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(26)",
    width: 118,
    height: 133.45,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSuccessExtended);
export default __webpack_public_path__ + "static/media/signupSuccessExtended.67552a49e867478703550bc3e848b68c.svg";
export { ForwardRef as ReactComponent };